import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { withFirebase } from '../Firebase';
import iconDelete from "../../assets/delete.svg";
import Modal from "react-responsive-modal";
import DeleteIdeaOrPollModal from "../Challenge/IdeaSection/DeleteIdeaOrPollModal"
import Tooltip from '@material-ui/core/Tooltip';

import "./SinglePoll.css";

class SinglePoll extends Component {

  render() {
    if (this.props.answered === true) {
      return (
        <VisitedSinglePollComponent {...this.props} />
      );
    }
    else {
      return (
        <NonVisitedSinglePollComponent {...this.props} />
      );
    }
  }
}

const INITIAL_STATE = {
  deleteOpen: false,
  deleteConfirmed: false
};

class NonVisitedSinglePollComponentBase extends Component {

  constructor(props) {
    super(props);
    this.state = { ...INITIAL_STATE };
  }

  openDelete = () => {
    this.setState({
      deleteOpen: true
    })
  }

  closeDelete = (status) => {
    this.setState({
      deleteOpen: false
    })
    if (status === 'accept') {
      this.setState({ deleteConfirmed: true })
    }
  }

  onDeleteExited = () => {
    const { deleteConfirmed } = this.state
    if (deleteConfirmed) {
      window.location.reload();
    }
  }

  showDelete = () => {
    let creatorId = this.props.poll ? this.props.poll.creatorId : this.props.firebase.auth.currentUser.uid
    let currentUserId = this.props.firebase.auth.currentUser.uid
    if (creatorId === currentUserId) {
      return true
    }
    else return false
  }

  render() {
    return (
      <>
        <div className="poll-container">
          <Tooltip title="Supprimer le sondage" aria-label="supprimer sondage">
            <img hidden={!this.showDelete()} className="icon-delete-poll" src={iconDelete} onClick={this.openDelete} alt="deletePoll" />
          </Tooltip>
          <div className="poll-image-container"><img onClick={this.props.onClick} className="non-visited-poll-picture" src={this.props.src} alt="Poll" /></div>
          <div className="poll-tag">{this.props.topic}</div>
        </div>
        <Modal
          open={this.state.deleteOpen}
          onClose={this.closeDelete}
          center
          showCloseIcon={true}
          styles={styles_delete}
          onExited={this.onDeleteExited}
        >
          <DeleteIdeaOrPollModal
            onClose={this.closeDelete}
            openDelete={this.openDelete}
            capsuleId={this.props.capsuleId}
            elementId={this.props.pollId}
            elementType={'poll'} />

        </Modal>
      </>)
  }
}

class VisitedSinglePollComponentBase extends Component {


  constructor(props) {
    super(props);
    this.state = { ...INITIAL_STATE };
  }

  openDelete = () => {
    this.setState({
      deleteOpen: true
    })
  }

  closeDelete = (status) => {
    this.setState({
      deleteOpen: false
    })
    if (status === 'accept') {
      this.setState({ deleteConfirmed: true })
    }
  }

  onDeleteExited = () => {
    const { deleteConfirmed } = this.state
    if (deleteConfirmed) {
      window.location.reload();
    }
  }

  showDelete = () => {
    let creatorId = this.props.poll ? this.props.poll.creatorId : this.props.firebase.auth.currentUser.uid
    let currentUserId = this.props.firebase.auth.currentUser.uid
    if (creatorId === currentUserId) {
      return true
    }
    else return false
  }

  render() {
    return (
      <>
        <div className="poll-container">
          <Tooltip title="Supprimer le sondage" aria-label="supprimer sondage">
            <img hidden={!this.showDelete()} className="icon-delete-poll" src={iconDelete} onClick={this.openDelete} alt="deletePoll" />
          </Tooltip>
          <div className="poll-image-container"><img onClick={this.props.onClick} className="visited-poll-picture" src={this.props.src} alt="Poll" /></div>
          <div className="poll-tag">{this.props.topic}</div>
        </div>
        <Modal
          open={this.state.deleteOpen}
          onClose={this.closeDelete}
          center
          showCloseIcon={true}
          styles={styles_delete}
          onExited={this.onDeleteExited}
        >
          <DeleteIdeaOrPollModal
            onClose={this.closeDelete}
            openDelete={this.openDelete}
            capsuleId={this.props.capsuleId}
            elementId={this.props.pollId}
            elementType={'poll'} />

        </Modal>
      </>)
  }
}

const styles_delete = {
  overlay: {
    display: "block",
    position: "fixed",
    left: 0,
    top: 0,
    zIndex: 9999,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0,0,0,0.79)",
    overflow: "auto",
  },
  modal: {
    boxShadow: 'none',
    borderRadius: '4px',
    minHeight: "355px",
    maxWidth: "321px",
    top: "10%",
    padding: "0px",
  }
};

const NonVisitedSinglePollComponent = withRouter(withFirebase(NonVisitedSinglePollComponentBase));
const VisitedSinglePollComponent = withRouter(withFirebase(VisitedSinglePollComponentBase));

export default SinglePoll;
export { NonVisitedSinglePollComponent, VisitedSinglePollComponent };